const roundTo5 = (val: number) => Math.round(val * 20) / 20;

export const calculateSubTotalPrice = (
  price: number | undefined,
  discount: number | undefined
) => {
  if (price !== undefined) {
    let brutto = price;
    if (discount !== undefined) {
      brutto = price - (price * discount) / 100;
    }
    return brutto.toFixed(2);
  }
  return "0.00";
};

export const calculateTax = (
  price: number | undefined,
  discount: number | undefined,
  taxRate: number
) => {
  if (price === undefined) return "0.00";
  let brutto = price;
  if (discount !== undefined && discount > 0) {
    brutto = price - (price * discount) / 100;
  }
  let tax = (brutto * taxRate) / 100;
  if (taxRate > 0) {
    tax = roundTo5(tax);
  }
  return tax.toFixed(2);
};

export const calculateTotalPrice = (
  price: number | undefined,
  discount: number | undefined,
  taxRate: number
) => {
  if (price === undefined) return "0.00";
  let brutto = price;
  if (discount !== undefined && discount > 0) {
    brutto = price - (price * discount) / 100;
  }
  let tax = (brutto * taxRate) / 100;
  if (taxRate > 0) {
    tax = roundTo5(tax);
    const total = roundTo5(brutto + tax);
    return total.toFixed(2);
  } else {
    return (brutto + tax).toFixed(2);
  }
};
